import { Entity, Type } from '@decahedron/entity';
import Car from '@/entities/Car';
import Formatter from '@/support/formatter';
import User from '@/entities/User';

export default class Bid extends Entity {
    protected formatter = new Formatter();

    public id: number = null;

    public amount: number = null;

    @Type(Car) public car: Car = null;

    @Type(User) public user: User = null;

    get amountString(): string {
        return `€ ${this.formatter.formatNumber(this.amount)},-`;
    }
}
